import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-616e227a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
import TopOpenView from '@/components/common/top-open-view.vue'; // import autoHidebar from '@/components/common/auto-hide-bar.vue'

import composition from '@/composition'; // import ua from '@/utils/platform'

export default {
  props: {
    isShowDownload: {
      default: true,
      type: Boolean
    },
    categories: Array,
    model: Object,
    showPublish: Boolean,
    isPublish: Boolean
  },

  setup(__props) {
    const props = __props;
    const {
      openApp,
      getQueryString,
      store,
      isIframe,
      fs_device,
      openCustomPage
    } = composition(); // const isApp = ua.isFsPlus

    const query = getQueryString();

    if (query && query.cid) {
      store.state.pageCid = query.cid;
    } // 发布


    function publish() {
      // const cids = [389, 383, 411, 270, 445, 157, 153, 365, 457, 438, 434, 458, 242, 481, 531]
      if (props.model.type == 'MOMENT') {
        if (props.model.category && props.model.category.webCreatePostState) {
          // 话题
          openCustomPage(`publish/index.html?tid=${props.model.id}`);
        } else if (props.model.webCreatePostState == true) {
          // 频道
          openCustomPage(`publish/index.html?cid=${props.model.id}`);
        } else {
          openApp();
        }
      } else {
        openApp();
      }
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(isIframe) && __props.isShowDownload && _unref(fs_device) != 0 ? (_openBlock(), _createBlock(TopOpenView, {
        key: 0,
        categories: __props.categories,
        model: __props.model
      }, null, 8, ["categories", "model"])) : _createCommentVNode("", true), __props.isPublish || __props.model && __props.model.id ? _renderSlot(_ctx.$slots, "main", {
        key: 1
      }) : _createCommentVNode("", true), __props.showPublish ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "publish-btn",
        onClick: _cache[0] || (_cache[0] = $event => publish())
      })) : _createCommentVNode("", true)]);
    };
  }

};